import { render, staticRenderFns } from "./Communicate.vue?vue&type=template&id=66eb9408"
import script from "./Communicate.vue?vue&type=script&lang=js"
export * from "./Communicate.vue?vue&type=script&lang=js"
import style0 from "./Communicate.vue?vue&type=style&index=0&id=66eb9408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports